import { combineEpics } from 'redux-observable';

import * as accountDelegations from './account-delegations/epics';
import * as activeAccountDelegations from './active-account-delegations/epics';
import * as paginatedBlocksEpics from './paginated-blocks/epics';
import * as paginatedDeploysEpics from './paginated-deploys/epics';
import * as currencyEpics from './fiat-currencies/epics';

export default combineEpics(
  ...Object.values(accountDelegations),
  ...Object.values(activeAccountDelegations),
  ...Object.values(paginatedBlocksEpics),
  ...Object.values(paginatedDeploysEpics),
  ...Object.values(currencyEpics)
);
